
import { Link } from 'react-router-dom';

const ThankYou = () => {
  return (
    <div className="d-flex align-items-center justify-content-center vh-100 "> {/* Full viewport height, light background */}
      <div className="text-center p-5 bg-white rounded shadow-lg animate__animated animate__fadeIn"> {/* Centered content, padding, white background, rounded corners, shadow, and a fade-in animation */}
        <h1 className="display-3 text-success mb-3">
          <i className="bi bi-check-circle-fill me-2"></i> {/* Bootstrap Icon: Checkmark (add 'bootstrap-icons' to your project if not already) */}
          Thank You!
        </h1>
        <p className="lead text-secondary mb-4">
          Your message has been successfully received.
        </p>
        <p className="mb-4">
          We appreciate you reaching out and will get back to you very soon.
        </p>
        <hr className="my-4" /> {/* Horizontal line for separation */}
        <p className="text-muted small">
          In the meantime, feel free to explore more of our site.
        </p>
        <Link to="/" className="btn btn-primary btn-lg mt-3">
          <i className="bi bi-house-door-fill me-2"></i> {/* Bootstrap Icon: Home */}
          Return to Homepage
        </Link>
      </div>
    </div>
  );
};

export default ThankYou;